








import Vue from "vue";
export interface MultiTabState {
  value: number[];
  toggle: (value: number) => void;
}

interface Provide {
  getMultiSelectState: () => MultiTabState;
}

export default Vue.extend({
  props: {
    value: {
      type: Array as () => number[],
      required: true
    }
  },
  provide(): Provide {
    return {
      getMultiSelectState: this.mulitSelectState
    };
  },

  methods: {
    mulitSelectState(): MultiTabState {
      return {
        value: this.value,
        toggle: this.toggleValue
      };
    },
    toggleValue(toggleItem: number) {
      if (this.value.includes(toggleItem)) {
        this.$emit(
          "input",
          this.value.filter(v => v !== toggleItem)
        );
      } else {
        this.$emit("input", [...this.value, toggleItem]);
      }
    }
  }
});
